const initialState = {
  loading: false,
  totalSupply: 0,
  isWhitelistedBool: false,
  addressMintedCnt: 0,
  feeJSON: "",
  cost: 0,
  error: false,
  errorMsg: "",
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECK_DATA_REQUEST":
      return {
        ...state,
        loading: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        totalSupply: action.payload.totalSupply,
        isWhitelistedBool: action.payload.isWhitelistedBool,
        addressMintedCnt: action.payload.addressMintedCnt,
        feeJSON: action.payload.feeJSON,
        // cost: action.payload.cost,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_FAILED":
      return {
        ...initialState,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default dataReducer;
